/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Active/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import CompleteAction from './CompleteAction/index'
import QrCode from 'DesignSystem/QrCode/react'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Active({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/CaptureImageRequest/Content/Content/Request/Content/Active"
  
}) {
let imagesRequestCreateUrlValueData = fromData.useDataValue({ viewPath,
context: 'images_request_create',
path: 'url',
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 text="The image capture process is currently active."
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 text="Scan the following QR code with your phone to take the pictures."
/>
<QrCode
  viewPath={`${viewPath}/QrCode`}
 marginBottom={dtSpaceM}
 marginTop={dtSpaceM}
 data="images_request_create.url"
 value={imagesRequestCreateUrlValueData}
 size={360}
/>
<div
  data-testid="Active.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-2jfVU5': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<CompleteAction
  viewPath={`${viewPath}/CompleteAction`}
/>
</div>
{children}
</React.Fragment>)
}